import { fromJS } from 'immutable';

const mergeStates = (e, oldState, name, value) => {
  const state = fromJS(oldState);
  let names = [];
  let val;

  if (typeof name !== 'undefined' && typeof value !== 'undefined') {
    if (Array.isArray(name)) {
      names = name;
    } else if (typeof name === 'string') {
      names = name.split('.');
    } else {
      names[0] = name;
    }
    val = value;
  } else {
    names = e.target.name.split('.');
    val = e.target.value;
  }

  return state.setIn(names, val).toJS();
};

export default mergeStates;



// WEBPACK FOOTER //
// ./src/helpers/mergeStates.js